import styled from '@emotion/styled'
import { spacing, colors, EINA_01_FONT } from '@retailer-platform/shared-components'
import React, { type FunctionComponent } from 'react'
import { useDomainMessages } from 'domains/shifts/utils/domain/intl'

const Container = styled.div({
  width: '40px',
  height: '17px',
  borderRadius: '2px',
  border: `1px solid ${colors.SECONDARY.REGULAR}`,
  padding: spacing.X4,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
})

const LiveDot = styled.div({
  width: spacing.X4,
  height: spacing.X4,
  borderRadius: '2px',
  backgroundColor: colors.PRIMARY.REGULAR,
})

const LiveText = styled.div({
  textTransform: 'uppercase',
  fontFamily: EINA_01_FONT,
  fontSize: '9px',
  lineHeight: '18px',
  color: colors.GRAYSCALE.X50,
})

interface Props {}

export const StaffingAlertLiveBadge: FunctionComponent<Props> = () => {
  const messages = useDomainMessages({
    live: 'shiftsDomain.staffingAlert.live',
  })
  return (
    <Container>
      <LiveDot />
      <LiveText>{messages.live}</LiveText>
    </Container>
  )
}
